import { Mic, Footprints, Type, GalleryHorizontal, Clapperboard, ShoppingBag, Sparkles } from "lucide-react";

const ICONS = { mic: Mic, footprints: Footprints, type: Type, "gallery-horizontal": GalleryHorizontal, clapperboard: Clapperboard, "shopping-bag": ShoppingBag };

export const FormatIcon = ({ icon, ...p }) => {
  const C = ICONS[icon] || Sparkles;
  return <C strokeWidth={1.5} {...p} />;
};

export const STATUS_STYLES = {
  draft: "bg-[#F4F2F7] text-[#6B6478]",
  generated: "bg-[#F1E9FE] text-[#9C4DDC]",
  posted: "bg-[#9C4DDC] text-white",
};

export const StatusChip = ({ status, testid }) => (
  <span className={`text-[11px] font-bold uppercase tracking-[0.12em] px-3 py-1 rounded-full ${STATUS_STYLES[status]}`} data-testid={testid}>{status}</span>
);

const sec = (title, body) => (body && body.trim() ? `== ${title} ==\n${body.trim()}\n` : "");

export const SECTION_TEXT = {
  image_prompts: (o) => o.image_prompts.map((p) => `${p.label}:\n${p.prompt}`).join("\n\n"),
  video_shots: (o) => o.video_shots.map((s) => `${s.label} (${s.duration_seconds}s)\nCamera: ${s.camera}\nAction: ${s.action}${s.dialogue ? `\nDialogue: ${s.dialogue}` : ""}\nPrompt: ${s.prompt}`).join("\n\n"),
  carousel_slides: (o) => o.carousel_slides.map((s) => `Slide ${s.slide}: ${s.text}${s.visual_note ? `\n  Visual: ${s.visual_note}` : ""}`).join("\n"),
  on_screen_text: (o) => o.on_screen_text,
  caption: (o) => o.caption,
  hashtags: (o) => o.hashtags.join(" "),
  keyword_dm: (o) => `Comment keyword: ${o.comment_keyword}\n\nDM message:\n${o.dm_message}`,
  posting_tips: (o) => o.posting_tips.map((t) => `- ${t}`).join("\n"),
};

export function copyEverything(card) {
  const o = card.output;
  return [
    `${card.muse?.name || "Muse"} — ${card.quote}\n`,
    sec("IMAGE PROMPTS", SECTION_TEXT.image_prompts(o)),
    sec("VIDEO SHOTS", SECTION_TEXT.video_shots(o)),
    sec("CAROUSEL SLIDES", SECTION_TEXT.carousel_slides(o)),
    sec("ON-SCREEN TEXT", o.on_screen_text),
    sec("CAPTION", `${o.caption}\n\n${o.hashtags.join(" ")}`),
    sec("COMMENT KEYWORD + DM", SECTION_TEXT.keyword_dm(o)),
    sec("POSTING TIPS", SECTION_TEXT.posting_tips(o)),
  ].filter(Boolean).join("\n");
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
  }
}
